module.exports = __webpack_public_path__ + "static/img/qdsb.4aefaf69.png";